import { render, staticRenderFns } from "./live.vue?vue&type=template&id=67596bf8&scoped=true"
import script from "./live.js?vue&type=script&lang=js&external"
export * from "./live.js?vue&type=script&lang=js&external"
import style0 from "./live.vue?vue&type=style&index=0&id=67596bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67596bf8",
  null
  
)

export default component.exports